var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomerCard',{attrs:{"jobId":_vm.jobId,"customer":_vm.Customer,"address":_vm.CustomerAddress,"contact":_vm.CustomerContact,"isOrder":_vm.isOrder,"fillHeight":false}})}
var staticRenderFns = []

export { render, staticRenderFns }